/** @format */

import "./About.scss";

import profilePicture from "../../assets/images/about_image.png";

export default function About() {
  return (
    <div id="AboutMe" className="about-container">
      <div className="about">
        <h5 className="about__name">Wahaj Arsal</h5>
        <h2 className="about__title">About Me</h2>
        <div className="about__information">
          <div className="about__picture">
            <img className="about__image" src={profilePicture} alt="profile" />
          </div>
          <div className="about__details">
            <p className="about__text">
              I am a Full Stack Developer specialising in JavaScript, React,
              Redux, Node.js.
              <br />
              <br />
              My current interests include learning and building web
              applications using JavaScript, React and Node.js.
              <br />
              <br />I have 2 years of experience working at a startup, building
              and maintaining an online live streaming platform.
            </p>
            <div className="skills-container">
              <h5 className="skills">
                Here are some of the technologies I have worked with
              </h5>
              <ul className="about__tech">
                <li className="about__skill">JavaScript</li>
                <li className="about__skill">React</li>
                <li className="about__skill">Redux</li>
                <li className="about__skill">Node.js</li>
                <li className="about__skill">Express</li>
                <li className="about__skill">MySQL</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
